// BR_Custom PDP Gallery Scroll Progress
(() => {
  const initGalleryScrollProgress = () => {
    const wrappers = document.querySelectorAll(
      ".product-single__wrapper--gallery-inner-scroll",
    );

    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      const gallery = wrapper.querySelector(
        ".product-single__gallery.product-single__gallery--equal",
      );

      if (!gallery) return;
      if (gallery.dataset.brGalleryProgressInit === "true") return;

      gallery.dataset.brGalleryProgressInit = "true";

      const progressBar = document.createElement("div");
      progressBar.className = "br-gallery-progress";
      progressBar.setAttribute("aria-hidden", "true");
      gallery.prepend(progressBar);

      const updateProgress = () => {
        const maxScroll = gallery.scrollHeight - gallery.clientHeight;
        const progress = maxScroll > 0 ? gallery.scrollTop / maxScroll : 0;

        gallery.style.setProperty(
          "--br-gallery-progress",
          Math.min(Math.max(progress, 0), 1),
        );
      };

      let ticking = false;

      const requestUpdate = () => {
        if (ticking) return;

        ticking = true;

        requestAnimationFrame(() => {
          updateProgress();
          ticking = false;
        });
      };

      gallery.addEventListener("scroll", requestUpdate, { passive: true });
      window.addEventListener("resize", requestUpdate);

      updateProgress();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGalleryScrollProgress);
  } else {
    initGalleryScrollProgress();
  }
})();
// End BR_Custom PDP Gallery Scroll Progress